import type { WishlistMixpanelEvents } from '../../constants/mixpanel-events';
import { page } from '$app/state';
import { track } from '$global/utils/track';

interface WishlistEventDetails {
	artworkId: string | null | undefined;
	artist: string | null | undefined;
	// Defaults to the current route id; pass explicitly when the action happens
	// outside a page context (e.g. the wishlist drawer overlay).
	sourcePage?: string;
}

export const trackWishlistEvent = (
	trackPrefix: string,
	event: WishlistMixpanelEvents,
	{ artworkId, artist, sourcePage }: WishlistEventDetails
) => {
	track(`${trackPrefix}/${event}`, {
		artwork_id: artworkId,
		artist,
		source_page: sourcePage ?? page.route.id,
	});
};
